<template>
    <div id="replyTender">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/backStandard/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>评标回复</span></h2>
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <section class="small-container">
                <h2>
                    <img src="../../../assets/images/invitemanage/tit01.png"/>
                    <!--<el-button type="primary"><i class="downloadIcon"></i>下载全部</el-button>-->
                </h2>
                <el-table
                    :data="extWFlowFormInquiringBids"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        label="评标问卷名称">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row,2)" title="点击下载">
                                {{ scope.row.askAttachName }}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="inquiringBidSendTime"
                        label="评标问卷发出时间">
                    </el-table-column>
                    <el-table-column
                        prop="downloadTime"
                        label="评标问卷下载时间">
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        label="评标回复文件名称">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row,1)" title="点击下载">
                                {{ scope.row.answerAttachName }}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="250">
                        <template slot-scope="scope">
                            <div v-if="isTime && scope.row.isShow">
                                <div style="display: inline-block;">
                                    <page-upload :files="fileList"
                                                 v-on:finishUpload="finishUploadFile"
                                                 @click.native="clickRow(scope.row)"
                                                 :editFlag="true"
                                                 attachmentType=""
                                                 :limitType="2"
                                                 :isIconTable="3"
                                                 :notMany="true"
                                                 :notViewList="true">
                                    </page-upload>
                                </div>
                                <el-button
                                    @click="submit(scope.row)"
                                    :disabled="scope.row.answerAttachName ? false : true"
                                    style="padding:9px 18px;"><i class="el-icon-document" style="margin-right:3px;"></i>提交</el-button>
                            </div>
                            <el-button v-else type="text">已回复</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <p style="text-align:left;margin-top: 20px;"><span class="tips">提示：回复评标问卷，附件上传后必须提交，否则管理员无法看到回复的附件！</span></p>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'replyTender',
        data() {
            return {
                projectName: '',//项目名称
                extWFlowFormInquiringBids: [],//询标问卷 回复
                fileList: [],
                inquiringBidTime: '',//询标截止时间
                currentRow: '',//当前行
                isTime: true,//是否过了询标截止时间 true 未过期
            }
        },
        created(){
            this.$root.activeIndex = 'win';
            this.getData();//初始化数据
        },
        methods: {
            getData(){//获取数据
                let that = this;
                this.$root.getHttp('/v1/outerformflow/inquiringBid/list?formId='+this.$route.params.formId,function (res) {
                    that.extWFlowFormInquiringBids = res.data.data.extWFlowFormInquiringBids;
                    that.inquiringBidTime = res.data.data.inquiringBidTime;
                    that.isTime = res.data.data.isTime;
                    that.projectName = res.data.data.dealBisVo.flowFormExtMng.formTitle;
                    that.extWFlowFormInquiringBids.forEach( item => {
                        item.isShow = true;
                        if(item.answerAttachName) {
                            item.isShow = false;
                        }
                    })
                })
            },
            clickRow(row){
                this.currentRow = row;
            },
           submit(row){
               let that = this;
               that.$confirm('提交回复后不可更改，是否继续？',{
                   type:'warning',
                   confirmButtonText: '确定',
                   cancelButtonText: '取消'
               }).then( () => {
                   that.$root.postHttp('/v1/outerformflow/inquiringBid/submit',{
                       formId: row.flowFormId,
                       id: row.id,
                       sattachment: that.fileList[0]
                   },function (res) {
                       that.$message.success('回复成功');
                       that.getData();
                   });
               }).catch(() => {
                   that.$message({
                       type: 'info',
                       message: '已取消回复'
                   })
               });
           },
            finishUploadFile(val){//文件上传完成后，同步询标回复数据；
                this.fileList = val.fileList;
                if(val.fileList.length){
                    this.currentRow.answerAttachName = val.fileList[0].attachName;
                }
            },
            fileListHandleDownload(val,type) {
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then( () => {
                    if(type == 1){
                        that.$root.downloadFile({
                            attachName: val.answerAttachName,
                            attachPath: val.answerAttachUrl || val.askAttachUrl
                        });
                    }else {
                        that.$root.postHttp('/v1/outerformflow/bidFile/down',{
                            formId: val.flowFormId,
                            relatedId: val.id,
                            type: val.askAttachType
                        },function (res) {
                            //code 1 成功了再进行下载
                            that.$root.downloadFile({
                                attachName: val.askAttachName,
                                attachPath: val.askAttachUrl
                            });
                            that.getData();
                        });
                    }

                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消下载'
                    })
                });
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#replyTender {
    padding-bottom: 50px;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        margin-top: 80px;
        img {
            width: 100%;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding-bottom: 60px;
        /*background: #fff;*/
    }
    .el-tabs {
        background: #fff;
        /*padding-top: 20px;*/
        & .el-tabs__header {
            margin: 0 0 10px;
        }
        & .el-tabs__nav {
            margin-left: 40px;
        }
        & .el-tabs__item {
            font-size: 14px;
            height: 50px;
        }
        & .el-tabs__item.is-active {
            color: $--text-color;
            font-weight: 700;
        }
        & .el-tabs__active-bar {
            bottom: -2px;
            height: 12px;
            background: url('../../../assets/images/register/at.png') no-repeat center 0;
        }
        & .el-tabs__nav-wrap::after {
            height: 1px;
            background-color: $--secondary-fill-color;
        }
    }
    .small-container {
        width: 1200px;
        box-sizing: border-box;
        margin: 0px auto;
        padding: 30px 50px 30px;
        background: #fff;
        h2 {
            /*margin-top: 50px;*/
            overflow: hidden;
            img {
                float: left;
                width: 282px;
                height: 30px;
            }
            .el-button {
                float: right;
                padding: 5px 25px;
                height: 30px;
                i {
                    display: inline-block;
                    margin-right: 8px;
                    width: 20px;
                    height: 20px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/invitemanage/icon04.png') no-repeat;
                    background-position: 0 center;
                }
            }
        }
        .el-table{
            margin-top: 20px;
            th {
              text-align: center;
            }
            & .words {
                color: #333;
                text-decoration: none;
            }
            & .words:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
        }
        & .tips {
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            color: $--primary-color;
            background: url('../../../assets/images/register/icon03.png') no-repeat left center;
        }
    }
    .uploadWrap {
        margin-top: 20px;
        min-height: 200px;
        /*background: #fff url('../../../assets/images/invitemanage/icon02.png') no-repeat center 140px;*/
        h2 img {
            width: 214px;
            height: 30px;
        }
        .el-upload {
            float: right;
        }
        .file-list {
            display: none;
            min-height: 230px;
            padding-top: 50px;
            min-height: 200px;
            .delBtn {
                display: none;
                margin-left: 10px;
            }
            td {
                position: relative;
            }
            .el-table__body tr:hover > td .delBtn{
                display: inline-block;
                position: absolute;
                right: 0;
                top: 6px;
            }
            & .words {
                max-height: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #333;
                text-decoration: none;
            }
            & .words:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
        }
        .uploadCon {
            padding: 65px 0 15px;
            line-height: 34px;
            /*margin-top: 85px;*/
            .big {
                font-size: 16px;
                color: $--text-color-light;
            }
            .small {
                font-size: 14px;
                color: $--text-color-lighter;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/ReplyTender.vue